<template>
  <div>
    <loading :showLoading="load" />
    <div class="Create alignment">
      <v-container>
        <v-row dense>
          <v-col>
            <v-text-field
              v-model="userDivisionDescription"
              :label="$t('Request.DivisionDescription')"
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="userBUDescription"
              :label="$t('Request.BUDescription')"
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-text-field
              v-model="dateCreated"
              :label="$t('Request.DateCreated')"
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="status"
              :label="$t('Request.Status')"
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-text-field v-model="title" :label="$t('Request.Title')" disabled>
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="shipmentNumber"
              :label="$t('Request.ShipmentNumber')"
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-text-field
              v-model="sender"
              :label="$t('Request.Sender')"
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="senderCountry"
              :label="$t('Request.SenderCountry')"
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-text-field
              v-model="recipient"
              :label="$t('Request.Recipient')"
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="recipientCountry"
              :label="$t('Request.RecipientCountry')"
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-text-field
              v-model="dateTransport"
              :label="$t('Request.DateTransport')"
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="isExternalCompany"
              :label="$t('Request.IsExternalCompany')"
              disabled
            >
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-text-field
              v-model="externalCompany"
              :label="$t('Request.ExternalCompany')"
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="carriersCode"
              :label="$t('Request.CarriersCodeList')"
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-text-field
              v-model="vehiclesType"
              :label="$t('Request.VehiclesCodeList')"
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="category"
              :label="$t('Request.Category')"
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-text-field
              v-model="grossWeight"
              :label="$t('Request.GrossWeight')"
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field v-model="value" :label="$t('Request.Value')" disabled>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-text-field
              v-model="valueGuaranteed"
              :label="$t('Request.ValueGuaranteed')"
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="warranty"
              :label="$t('Request.Warranty')"
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="padding-left: 0px">
            <v-btn class="styleButtonTop border" @click="back()">
              <v-icon left>fas fa-check-circle</v-icon>
              {{ $t("SearchMenu.Button.Back") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import router from "@/router/index.js";
import { Trans } from "@/plugins/Translation";
import BackEndApi from "../../api/AllRisk/allRiskApi.js";
import IMApi from "../../api/IM/IMApi.js";
import loading from "../../components/loadingComponent.vue";
import moment from "moment";

export default {
  components: { loading },

  data() {
    return {
      load: false,
      showErr: false,
      textErr: "",
      statusId: 0,
      warrantyId: 0,

      // model
      username: "",
      dateCreated: "",
      status: "",
      states: [],
      title: "",
      shipmentNumber: "",
      sender: "",
      senderCountry: "",
      recipient: "",
      recipientCountry: "",
      dateTransport: "",
      isExternalCompany: false,
      externalCompany: "",
      carriersCode: "",
      companies: [],
      vehiclesType: "",
      selectedCategory: "",
      category: "",
      categories: [],
      grossWeight: "",
      value: "",
      valueGuaranteed: "",
      warranty: "",
      warranties: [],
      userBUDescription: "",
      userDivisionDescription: "",
    };
  },

  watch: {
    '$store.getters.GET_languageChanged': function() {
      
      this.category = Trans.currentLanguage=="it" ? this.selectedCategory.description : this.selectedCategory.descriptionEn;

      if(this.statusId!=0)
      {
        this.status = Trans.i18n.t("Status." + this.statusId);
      }

      if(this.warrantyId!=0)
      {
        this.warranty = Trans.i18n.t("Warranties." + this.warrantyId);
      }
    }

  },

  async created() {
    this.load = true;
    let id = this.$route.params.Id;

    if(id.length>0 && (Array.from(id)[0]=="$")){
      id = Buffer.from(id, 'base64').toString();
    }

    // only ad user can be access
    let aduserInfo_res = await IMApi.GetADUserInformationByUsername(
      this.$GAUserAuth.user.username
    );
    if (!aduserInfo_res.data) {
      this.$router.push({ name: "unauthorized" });
    }

    this.isAdmin = this.$GAUserAuth.isAdmin();
    this.isSupervisor = this.$GAUserAuth.isSupervisor();
    this.loggedUsername = this.$GAUserAuth.user.username;

    let get_all_statuses = id !== "undefined";
    let statuses_res = await BackEndApi.GetStatuses(get_all_statuses);
    this.statuses = statuses_res.data;

    let states_res = await IMApi.GetStates();
    this.states = states_res;

    let companies_res = await IMApi.GetExternalCompanies();
    this.companies = companies_res;

    let categories_res = await BackEndApi.GetCategoriesList();
    this.categories = categories_res.data;

    let warranties_res = await BackEndApi.GetWarranties();
    this.warranties = warranties_res.data;

    if (id) {
      BackEndApi.GetRequest(id)
        .then((response) => {
          //   console.log("request details", response.data);
          
          this.username = response.data.username;

          //   console.log("logged", this.loggedUsername, "username", this.username);
          // base user can view only theirs requests
          if (this.loggedUsername != this.username) {
            if (!this.isAdmin && !this.isSupervisor) {
              this.$router.push({ name: "unauthorized" });
            }
          }

          this.title = response.data.title;
          this.shipmentNumber = response.data.shipmentNumber;
          this.sender = response.data.sender;
          this.senderCountry = this.states.find(
            (x) => x.Id == response.data.senderCountryId
          ).CommonName;
          //   console.log("sender country", this.senderCountry);
          this.recipient = response.data.recipient;
          this.recipientCountry = this.states.find(
            (x) => x.Id == response.data.recipientCountryId
          ).CommonName;
          this.dateTransport = moment(response.data.dateTransport).format(
            "DD/MM/YYYY"
          );

          this.isExternalCompany = response.data.isExternalCompany;
          this.carriersCode = response.data.carriersCodeList;
          this.vehiclesType = response.data.vehiclesTypesList;

          this.selectedCategory = this.categories.find(
            (x) => x.id == response.data.categoryId
          );
          this.category = Trans.currentLanguage=="it" ? this.selectedCategory.description : this.selectedCategory.descriptionEn;

          this.grossWeight = response.data.grossWeight
            .toFixed(3)
            .toString()
            .replace(".", ",");
          this.value = response.data.value
            .toFixed(2)
            .toString()
            .replace(".", ",");
          this.valueGuaranteed = response.data.valueGuaranteed
            .toFixed(2)
            .toString()
            .replace(".", ",");

          this.warrantyId = response.data.warrantyId;
          this.warranty = Trans.i18n.t("Warranties." + this.warrantyId);

          if (response.data.externalCompanyId) {
            this.externalCompany = this.companies.find(
              (x) => x.Id == response.data.externalCompanyId
            )
              ? (this.externalCompany = this.companies.find(
                  (x) => x.Id == response.data.externalCompanyId
                ).Name)
              : "";
          }

          this.statusId = response.data.statusId;   
          this.status = Trans.i18n.t("Status." + this.statusId);

          this.dateCreated = moment(response.data.dateCreated).format(
            "DD/MM/YYYY"
          );

          IMApi.GetBU().then((bu_res) => {
            let bu = bu_res.Data.find((x) => x.Id == response.data.buId);
            if (bu) {
              this.userBUDescription = bu.Description;
              IMApi.GetDivisionWithDirector(bu.DivisionId).then(
                (division_res) => {
                  this.userDivisionDescription =
                    division_res.data.d.Description;
                }
              );
            }
          });

          this.load = false;
        })
        .catch((e) => {
          this.showErr = true;
          this.textErr = e.response;
          this.load = false;
        });
    } else {
      this.back();
    }
    this.load = false;
  },

  methods: {
    back() {
      router.push({ name: "home" });
    },
  },
};
</script>